export const DEFAULT_TUTORIAL_STATE = Object.freeze({
  enabled: false,
  completedLessonIds: Object.freeze([]),
  dismissedLessonIds: Object.freeze([]),
});

function stableStringList(value) {
  if (!Array.isArray(value)) return [];
  return [...new Set(value.filter((entry) => typeof entry === "string" && entry.trim()).map((entry) => entry.trim()))];
}

export function normalizeTutorialState(raw = {}) {
  return {
    enabled: Boolean(raw?.enabled),
    completedLessonIds: stableStringList(raw?.completedLessonIds),
    dismissedLessonIds: stableStringList(raw?.dismissedLessonIds),
  };
}

export function isTutorialLessonComplete(tutorialState, lessonId) {
  return normalizeTutorialState(tutorialState).completedLessonIds.includes(lessonId);
}

export function setTutorialEnabled(campaign, enabled) {
  const tutorial = normalizeTutorialState(campaign?.tutorial);
  if (tutorial.enabled === Boolean(enabled)) return campaign;
  return { ...campaign, tutorial: { ...tutorial, enabled: Boolean(enabled) } };
}

export function completeTutorialLesson(campaign, lessonId) {
  if (!lessonId) return campaign;
  const tutorial = normalizeTutorialState(campaign?.tutorial);
  if (tutorial.completedLessonIds.includes(lessonId)) return campaign;
  return {
    ...campaign,
    tutorial: {
      ...tutorial,
      completedLessonIds: [...tutorial.completedLessonIds, lessonId],
    },
  };
}

export function resetTutorialProgress(campaign) {
  const tutorial = normalizeTutorialState(campaign?.tutorial);
  if (!tutorial.completedLessonIds.length && !tutorial.dismissedLessonIds.length) return campaign;
  return {
    ...campaign,
    tutorial: {
      ...tutorial,
      completedLessonIds: [],
      dismissedLessonIds: [],
    },
  };
}
